import { APISERVICE } from "@api/RestClient";
import {
    createFetchError,
    createNotFoundError,
    normalizeResourceError,
    withRetry
} from "@util/apiError";

export const getFormTemplateByTemplateId = async (formTemplateId: string) => {
    try {
        const response = await withRetry(() =>
            APISERVICE.GET(`${process.env.NEXT_PUBLIC_GET_BASE_CATALOG_URL}/customFormTemplate?customFormTemplateId=${formTemplateId}`)
        );
        if (!response?.data?.data) throw createNotFoundError(response?.status);
        return response.data.data;
    } catch (error) {
        throw normalizeResourceError(error);
    }
};

export const getFormByGuestFormId = (guestFormId: string) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMER}/guestForm?guestFormId=${guestFormId}`)  //get store details
            .then(async (configResponse) => {
                if (configResponse.status == 200) {
                    const data = configResponse.data;
                    if (data?.data) {
                        res(data?.data)
                    } else {
                        rej({ err: 'custom form data unavailable' });
                    }
                } else if (configResponse.status == 401) {
                    rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_CUSTOMER}/guestForms?guestFormId=${guestFormId}`, status: configResponse.status });
                }
            }).catch(function (error) {
                rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_CUSTOMER}/guestForms?guestFormId=${guestFormId}`, status: error });
                console.error("error", error);
            });
    })
};

export const getFormsHistoryByGuestId = (guestId: string) => {
    return new Promise((res, rej) => {
        APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMER}/guestForms?guestId=${guestId}`)  //get store details
            .then(async (configResponse) => {
                if (configResponse.status == 200) {
                    const data = configResponse.data;
                    if (data?.data) {
                        res(data?.data)
                    } else {
                        rej({ err: 'custom form data unavailable' });
                    }
                } else if (configResponse.status == 401) {
                    rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_CUSTOMER}/guestForms?guestId=${guestId}`, status: configResponse.status });
                }
            }).catch(function (error) {
                rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_CUSTOMER}/guestForms?guestId=${guestId}`, status: error });
                console.error("error", error);
            });
    })
};

export const getFormTemplateByTemplateAndGuestId = async (customFormTemplateId: string, guestId: string) => {
    try {
        const response = await withRetry(() =>
            APISERVICE.GET(`${process.env.NEXT_PUBLIC_CUSTOMER}/guestFormForTemplate?customFormTemplateId=${customFormTemplateId}&guestId=${guestId}`)
        );
        return response?.data?.data || null;
    } catch (error) {
        // Only a probe for a previous submission. Any failure here must fall through to a blank
        // template rather than failing the whole form load.
        console.warn('Unable to check for an existing form submission', error);
        return null;
    }
};

// https://dev-respark.respark.in:8083/pcs-guest/v1/guestForm
export const submitFormTemplate = async (data: any) => {
    try {
        const response = await APISERVICE.POST(`${process.env.NEXT_PUBLIC_CUSTOMER}/guestForm`, data);
        if (!response?.data?.data) throw createFetchError(response);
        return response.data.data;
    } catch (error) {
        throw normalizeResourceError(error);
    }
};
